
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-sg",
      function () {
        return require("private-next-pages/why-sg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-sg"])
      });
    }
  